import { AutoComplete, type AutoCompleteProps } from 'antd';
import type { ComponentPropsWithoutRef } from 'react';
import { forwardRef } from 'react';
import styles from './DropdownControls.module.css';

/** AutoComplete hides its suffix icon by default; keep the Select affordance. */
export function DropdownAutoComplete(props: AutoCompleteProps) {
  const showDefaultChevron =
    props.suffixIcon === undefined && props.showArrow === undefined;
  const className = [
    props.className,
    showDefaultChevron ? styles.autoCompleteChevron : undefined,
  ]
    .filter(Boolean)
    .join(' ');

  return <AutoComplete {...props} className={className} />;
}

/** Keep the native select behavior while aligning its closed-state chevron. */
export const NativeSelect = forwardRef<
  HTMLSelectElement,
  ComponentPropsWithoutRef<'select'>
>(function NativeSelect({ className, ...props }, ref) {
  return (
    <select
      {...props}
      ref={ref}
      className={[styles.nativeSelect, className].filter(Boolean).join(' ')}
    />
  );
});
